import axios from 'axios';

const actionTokenValidation = (data) => (
  axios.post(
    `${process.env.REACT_APP_USER_API_ENDPOINT}/auth/action_token/validation`,
    data,
  ));

export default actionTokenValidation;
